// Node imports
import { ingenuity } from "@quest/base-core";
import { BackgroundController, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";


/**
 * BackgroundControllerGame class manages the background elements and visuals
 * within the game, providing functionality for dynamic updates, transitions,
 * and interactions related to the game's background.
 *
 * This class serves as a controller to handle background-related logic,
 * enhancing the overall gaming experience by seamlessly integrating and
 * controlling background elements in response to game events.
 */
export class BackgroundControllerGame extends BackgroundController {


      /**
     * method to initialize UI elements.
     */
  protected  initializeElements():void {
        this.basegameBgContainer = this.view.getContainerByID("basegameBgContainer");
        this.freegameBgContainer = this.view.getContainerByID("freegameBgContainer");
        this.gameIntroBgContainer = this.view.getContainerByID("gameIntroBgContainer");
        this.selectionScreenBGContainer = this.view.getContainerByID("SelectionScreenBGContainer");
        this.basegameBgSpineContainer = this.view.getContainerByID("backgroundSpineContainer");
        this.basegameIldeSpine = this.view.getSpineById("basegame_idle");
        this.freegameBgSpineContainer = this.view.getContainerByID("freegameBgSpineContainer");
        if (!ingenuity.deviceEnv.isDesktop) {
            this.basegameIldePortraitSpine = this.view.getContainerByID("backgroundSpinePortContainer").children[0];
        }
    }
  /**
   * This method plays the base game background spine
   */
  protected playBasegameIdleSpine(): void {
    this.basegameBgSpineContainer.visible = true;
    this.basegameIldeSpine && (this.basegameIldeSpine.visible = true);
    this.basegameIldeSpine && this.basegameIldeSpine.setPause(false);
    this.basegameIldeSpine.playAnim(SlotConstantsBehavior.BASEGAME_IDLE_SPINE, true);
    if (!ingenuity.deviceEnv.isDesktop) {
      this.playBasegamePortraitIdle();
    }
  }

  /**
   *  This method plays the base game background portrait spine
   */
  private playBasegamePortraitIdle(): void {
    this.basegameIldePortraitSpine && (this.basegameIldePortraitSpine.visible = true);
    this.basegameIldePortraitSpine && this.basegameIldePortraitSpine.setPause(false);
    this.basegameIldePortraitSpine && this.basegameIldePortraitSpine.playAnim("basegame_idle_portrait", true);
  }


  /**
   *  This method plays the free game background spine
   */
  protected playFreegameIdleSpine(): void {
    this.freegameBgSpineContainer.visible = true;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.playFreegamePortraitIdle();
    }
  }


  /**
   *  This method plays the free game background portrait spine
   */
  private playFreegamePortraitIdle(): void {
    // const spineDelay:number = 7000;
    // this.freegameBgPortraitrSpine && (this.freegameBgPortraitrSpine.visible = true);
    // this.freegameBgPortraitrSpine && this.freegameBgPortraitrSpine.playAnim(SlotConstantsBehavior.FREEGAME_IDLE_SPINE, false);
    // this.freegameBgPortraitrSpine && this.freegameBgPortraitrSpine.setPause(false);
    // this.freegameBgPortraitrSpine.onComplete.addOnce(() => {
    //   delayedCall(SlotConstantsBehavior.BASEGAME_SPINEDELAY, spineDelay, () => {
    //     killDelayedCall(SlotConstantsBehavior.BASEGAME_SPINEDELAY);
    //     this.playFreegameIdleSpine();
    //   });
    // }, this);
  }
}
